import { useEffect, useRef } from 'react';

import {
  acquireBackButton,
  releaseBackButton,
  updateBackButtonHandler,
} from './telegramBackButtonStack';

interface UseTelegramBackButtonOptions {
  visible: boolean;
  onBack: () => void;
  priority?: number;
}

export const useTelegramBackButton = ({
  visible,
  onBack,
  priority = 0,
}: UseTelegramBackButtonOptions): void => {
  const ownerIdRef = useRef<number | null>(null);
  const onBackRef = useRef(onBack);

  // Refresh handler without re-acquiring the stack slot.
  useEffect(() => {
    onBackRef.current = onBack;
    if (ownerIdRef.current !== null) {
      updateBackButtonHandler(ownerIdRef.current, () => onBackRef.current());
    }
  }, [onBack]);

  useEffect(() => {
    if (!visible) return undefined;

    const id = acquireBackButton(() => onBackRef.current(), priority);
    ownerIdRef.current = id;

    return () => {
      releaseBackButton(id);
      ownerIdRef.current = null;
    };
  }, [visible, priority]);
};
